import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PageInfo from './page_info';
import SidebarSearch from 'components/search_sidebar/sidebar_search';
import { Col, Row } from 'react-bootstrap-5';

export default class SearchPageFilterRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    hidePageData: PropTypes.bool,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number,
      itemCount: PropTypes.number,
      itemSingularLabel: PropTypes.string,
      pageSize: PropTypes.number,
      totalCount: PropTypes.number,
    }),
    renderContainerAsDiv: PropTypes.bool,
    searchFormGroupChildren: PropTypes.any,
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    onSearchChange: PropTypes.func,
  };

  static defaultProps = {
    newDesignSystem: false,
    searchPlaceholder: 'Search',
  };

  render() {
    const { children } = this.props;

    return (
      <Row className="align-items-center flex-wrap gy-2">
        <Col>
          <div className="d-flex gap-2 flex-lg-wrap flex-column flex-lg-row">
            {this.renderSearchBar()}
            {children}
          </div>
        </Col>
        {this.renderPageCount()}
      </Row>
    );
  }

  shouldRenderSearchBar() {
    return typeof this.props.onSearchChange === 'function';
  }

  renderSearchBar() {
    const { searchPlaceholder, searchText, onSearchChange } =
      this.props;

    if (!this.shouldRenderSearchBar()) return null;

    return (
      <SidebarSearch
        name="search_text"
        placeholder={searchPlaceholder}
        value={searchText}
        onChange={onSearchChange}
      >
        {this.props.searchFormGroupChildren}
      </SidebarSearch>
    );
  }

  renderPageCount() {
    if (!this.props.pageData) return null;

    // Can be made invisible (not display: none) to prevent elements from jumping around on hide
    return (
      <Col xl="auto" xs={12}>
        <div className="d-none d-md-inline-block">
          <PageInfo
            className={classNames('page-count d-none d-md-block', {
              invisible: this.props.hidePageData,
            })}
            name="page_count"
            {...this.props.pageData}
          />
        </div>
      </Col>
    );
  }
}
